import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ModelsPage from "../pages/models/page";
import StoryPage from "../pages/story/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/story",
    element: <StoryPage />,
  },
  {
    path: "/models",
    element: <ModelsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;